import { render, staticRenderFns } from "./RegView.vue?vue&type=template&id=5a6af5c4"
import script from "./RegView.vue?vue&type=script&lang=js"
export * from "./RegView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports